import { createContext,useContext } from 'react';

export interface User {
  id: string;
  email: string;
  rol: string;
  is_editor?: boolean;
  numeComplet?: string;
  esteContGoogle: boolean;
  needs_profile_completion?: boolean;
  dataCreare?: string;
  subscription_cancelled_at?: string;
  pro_status_active_until?: string;
  subscription_end_date?: string;
  subscription_start_date?: string;
  crm_storage_option?: string;
  post_auth_path?: string;
  session_replaced?: boolean;
  can_use_ai_navigation?: boolean;
  ai_navigation_access_version?: number;
  can_use_document_ai_professional_mode?: boolean;
  document_ai_professional_access_version?: number;
}

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  isReturningUser: boolean;
  login: (userData: User, nextPath?: string) => void;
  logout: () => void;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};


export function hasProAccess(user: User | null | undefined): boolean {
  if (!user) return false;
  const role = (user.rol || '').toLowerCase();
  if (role === 'admin') return true;
  if (role !== 'pro') return false;

  const endStr = user.subscription_end_date || user.pro_status_active_until;
  if (endStr) {
    const end = new Date(endStr);
    if (!isNaN(end.getTime()) && end.getTime() <= Date.now()) {
      return false;
    }
  }
  return true;
}
